import React, { useEffect, useRef, useState } from 'react';

import { ChevronLeft, ChevronRight } from '@hpi-sox/hpstellar-icons';
import { ArrowRight, ArrowLeft } from '@hpi-sox/hpstellar-vis-icons';

import withWindowResize from '../../../ui/components/window-resize';

import './scroll-container.less';

const SCROLL_DISTANCE = 144;
const SCROLL_END_BUFFER = 1;

function ScrollContainer({ children, className, width, visId, slim }) {
    const [overflow, setOverflow] = useState(width < 1572);
    const [left, setLeft] = useState(false);

    const scrollElement = useRef(null);

    const handleScroll = () => {
        const { scrollLeft, scrollWidth, offsetWidth } = scrollElement.current;

        setLeft(scrollLeft > 0);

        if (scrollLeft + offsetWidth >= scrollWidth - SCROLL_END_BUFFER) {
            setOverflow(false);
        } else {
            setOverflow(offsetWidth < scrollWidth);
        }
    };

    useEffect(() => {
        // TODO: find a way to add listener to size changes, currently not getting
        // the correct width on initial render so arrows not being set correctly
        setTimeout(() => {
            handleScroll();
        }, 1500);
    }, []);

    useEffect(() => {
        const { clientWidth, scrollWidth, offsetWidth } = scrollElement.current;
        //use the same buffer as handleScroll so a few px of rounding/border overflow isn't mistaken for real overflow
        const isOverflowing = offsetWidth < scrollWidth - SCROLL_END_BUFFER;

        setOverflow(isOverflowing);
        if (!isOverflowing) {
            //content fits at this width (arrows may even be force-hidden via CSS breakpoints), so clear any leftover scroll
            //position from a smaller viewport, otherwise cards stay scrolled out of view with no way to scroll back
            scrollElement.current.scrollLeft = 0;
            setLeft(false);
        }

        if (clientWidth === scrollWidth) {
            setLeft(false);
        }
        //slim toggles the sticky/non-sticky card sizing without changing viewport width, so it must also retrigger this recalculation
    }, [scrollElement, width, slim]);

    useEffect(() => {
        scrollElement.current.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            scrollElement?.current?.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const onClickScroll = (direction = true) => {
        scrollElement.current.scrollLeft += direction ? SCROLL_DISTANCE : -SCROLL_DISTANCE;
    };

    return (
        <>
            {left && (
                <div className="scrollButton left">
                    <button
                        type="button"
                        aria-label="Scroll Left"
                        className="slideButton"
                        onClick={() => onClickScroll(false)}
                    >
                        {visId ? <ArrowLeft size="s" /> : <ChevronLeft />}
                    </button>
                </div>
            )}
            <div className={`scrollContainer ${className}`} ref={scrollElement}>
                {children}
            </div>
            {overflow && (
                <div className="scrollButton right">
                    <button type="button" aria-label="Scroll Right" className="slideButton" onClick={onClickScroll}>
                        {visId ? <ArrowRight size="s" /> : <ChevronRight />}
                    </button>
                </div>
            )}
        </>
    );
}

export default withWindowResize(ScrollContainer);
